/**
 * English: 404 route — friendly message and link back to the dashboard.
 * Thai: เส้นทาง 404 — ข้อความเป็นมิตรและลิงก์กลับแดชบอร์ด
 */
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HomeIcon } from '@heroicons/react/24/outline';

export default function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center py-20">
      <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
      <h2 className="text-xl font-medium text-ink mb-2">{t('notFound.title')}</h2>
      <p className="text-sm text-muted mb-6">{t('notFound.description')}</p>
      <Link
        to="/"
        className="flex items-center gap-2 px-4 py-2 bg-primary hover:bg-primary-active text-white font-medium rounded-lg text-sm transition-colors"
      >
        <HomeIcon className="w-4 h-4" />
        {t('notFound.goHome')}
      </Link>
    </div>
  );
}
